// src/UserPlusIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var UserPlusIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "16",
    height: "22",
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.65079 0.0820312C4.89979 0.0820312 2.66329 2.31853 2.66329 5.06953C2.66329 7.76803 4.77379 9.95203 7.52479 10.0465C7.60879 10.036 7.69279 10.036 7.75579 10.0465C7.77679 10.0465 7.78729 10.0465 7.80829 10.0465C7.81879 10.0465 7.81879 10.0465 7.82929 10.0465C10.5173 9.95203 12.6278 7.76803 12.6383 5.06953C12.6383 2.31853 10.4018 0.0820312 7.65079 0.0820312Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12.9848 12.8395C10.0553 10.8865 5.27779 10.8865 2.32729 12.8395C0.993789 13.732 0.258789 14.9395 0.258789 16.231C0.258789 17.5225 0.993789 18.7195 2.31679 19.6015C3.78679 20.5885 5.71879 21.082 7.65079 21.082C9.58279 21.082 11.5148 20.5885 12.9848 19.6015C14.3078 18.709 15.0428 17.512 15.0428 16.21C15.0323 14.9185 14.3078 13.7215 12.9848 12.8395ZM9.75079 17.0185H8.43829V18.331C8.43829 18.7615 8.08129 19.1185 7.65079 19.1185C7.22029 19.1185 6.86329 18.7615 6.86329 18.331V17.0185H5.55079C5.12029 17.0185 4.76329 16.6615 4.76329 16.231C4.76329 15.8005 5.12029 15.4435 5.55079 15.4435H6.86329V14.131C6.86329 13.7005 7.22029 13.3435 7.65079 13.3435C8.08129 13.3435 8.43829 13.7005 8.43829 14.131V15.4435H9.75079C10.1813 15.4435 10.5383 15.8005 10.5383 16.231C10.5383 16.6615 10.1813 17.0185 9.75079 17.0185Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
var UserPlusIcon_default = UserPlusIcon;

export {
  UserPlusIcon_default
};
